import React, { useState, useEffect, useContext } from 'react'

import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Alert, Box, DialogActions, DialogTitle, Table, TableBody, TableRow } from "@mui/material"
import { Navigate, useNavigate } from "react-router-dom"
import Cookies from "js-cookie"
import { api } from '../network/api'
import { UserData, UserDataContext } from '../auth'
import { getDefaultHeroId } from '../util/heroSelect'

export default function Auth () {
    const [ open, setOpen ] = useState( false )
    const [ loginError, setLoginError ] = useState( "" )
    const [ registerError, setRegisterError ] = useState( "" )
    const navigate = useNavigate()
    const ctx = useContext( UserDataContext )
    if ( !ctx ) {
        throw new Error( 'useUserData must be used within a UserDataProvider' )
    }

    const handleClickOpen = () => {
        setRegisterError( "" )
        setOpen( true )
    }

    const handleClose = () => {
        setLoginError( "" )
        setOpen( false )
    }

    const handleLogin = () => {
        let name = ( document.getElementById( 'player_name' ) as HTMLInputElement ).value
        let password = ( document.getElementById( 'player_password' ) as HTMLInputElement ).value
        if ( name === "" || password === "" ) {
            setLoginError( "用户名或密码不能为空" )
            return
        }
        api.post( "login", { username: name, password: password } )
            .then( response => {
                let user: UserData = response.data
                ctx.setUserName( name )
                ctx.setUserData( user )

                // 默认英雄 = 后端暴露的激活英雄（activeHeroID，usersys withActiveHeroID）
                // 始终调用 setHeroId：无激活英雄（零英雄）时传 null 清除残留 heroID（跨账号场景）
                const defaultHeroId = getDefaultHeroId( user )
                ctx.setHeroId( defaultHeroId )
                navigate( "/英雄/我的英雄" )
                setLoginError( "" )
            } )
            .catch( error => {
                console.error( 'login error:', error )
                setLoginError( error.response?.data ?? '网络错误，请稍后重试' )
            } )
    }

    const handleRegister = () => {
        let name = ( document.getElementById( 'register_name' ) as HTMLInputElement ).value
        let password = ( document.getElementById( 'register_password' ) as HTMLInputElement ).value
        let repeat = ( document.getElementById( 'register_password_repeat' ) as HTMLInputElement ).value
        if ( name === "" || password === "" ) {
            setRegisterError( "用户名或密码不能为空" )
            return
        }
        if ( password !== repeat ) {
            console.log( password )
            console.log( repeat )
            setRegisterError( "两次输入的密码不一致" )
            return
        }
        api.post( "register", { username: name, password: password } )
            .then( response => {
                ctx.setUserName( name )
                ctx.setUserData( response.data )
                navigate( "/英雄/我的英雄" )
                setRegisterError( "" )
            } )
            .catch( error => {
                console.error( 'register error:', error )
                setRegisterError( error.response?.data ?? '网络错误，请稍后重试' )
            } )
    }

    return (
        <main>
            <Card>
                <CardContent >
                    <TextField
                        required
                        id="player_name"
                        label="用户名"
                    />
                    <TextField
                        required
                        id="player_password"
                        label="密码"
                    />
                    <Dialog open={ !( loginError === "" ) } onClose={ () => handleClose() }>
                        <Alert severity="error">{ loginError }</Alert>
                    </Dialog>
                </CardContent>
                <CardActions>
                    <Button onClick={ handleLogin } variant="outlined" fullWidth>登录</Button>
                    <Button onClick={ handleClickOpen } variant="outlined" fullWidth>注册</Button>
                </CardActions>
            </Card>
            <Dialog open={ open } onClose={ () => handleClose() }>
                <DialogContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TextField
                                    required
                                    id="register_name"
                                    label="用户名"
                                />
                            </TableRow>
                            <TableRow>
                                <TextField
                                    required
                                    id="register_password"
                                    label="密码"
                                />
                            </TableRow>
                            <TableRow>
                                <TextField
                                    required
                                    id="register_password_repeat"
                                    label="重复密码"
                                />
                            </TableRow>
                            <TableRow>
                                <div style={ { display: registerError === "" ? 'none' : 'block' } }>
                                    <Alert severity="error">{ registerError }</Alert>
                                </div>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={ () => handleRegister() } fullWidth>注册</Button>
                </DialogActions>
            </Dialog>
        </main >
    )
}
